import manifest from './voice-manifest.json';

const FEMALE =
  /hoda|salma|laila|layla|fatima|zariyah|zira|sara|sarah|samantha|female|woman|google العربية|google.*arabic/i;
const MALE = /naayf|nasser|maged|majed|tarik|mark|david|daniel|male|man|ماجد|طارق/i;

const CLIPS = manifest;

let token = 0;
let currentAudio = null;

function allVoices() {
  if (typeof window === 'undefined' || !window.speechSynthesis) return [];
  return window.speechSynthesis.getVoices();
}

export function speechSupported() {
  return (
    typeof window !== 'undefined' &&
    ('speechSynthesis' in window || typeof Audio !== 'undefined')
  );
}

function isFemale(voice) {
  if (MALE.test(voice.name) && !FEMALE.test(voice.name)) return false;
  return FEMALE.test(voice.name);
}

export function listVoices(lang) {
  if (lang === 'ar') {
    return [
      {
        uri: 'ara',
        name: 'Ara',
        label: 'آرا — صوت المرأة',
        lang: 'ar',
        female: true,
        score: 100,
        recommended: true,
      },
    ];
  }
  const list = allVoices()
    .filter((v) => v.lang.toLowerCase().replace('_', '-').startsWith('en'))
    .map((v) => ({
      uri: v.voiceURI,
      name: v.name,
      label: v.name,
      lang: v.lang,
      female: isFemale(v),
      score: isFemale(v) ? 20 : 5,
      recommended: false,
    }))
    .sort((a, b) => b.score - a.score);
  if (list[0]) list[0].recommended = true;
  return list;
}

export function bestVoice(lang) {
  return listVoices(lang)[0];
}

export function stopSpeech() {
  token += 1;
  if (currentAudio) {
    currentAudio.onended = null;
    currentAudio.pause();
    currentAudio.src = '';
    currentAudio = null;
  }
  if (typeof window !== 'undefined' && window.speechSynthesis) {
    window.speechSynthesis.cancel();
  }
}

function clipUrl(phrase) {
  return CLIPS[phrase] ?? CLIPS[String(phrase).trim()];
}

function playClips(urls) {
  const my = token;
  const play = (i) => {
    if (my !== token || i >= urls.length) return;
    const audio = new Audio(urls[i]);
    currentAudio = audio;
    audio.onended = () => play(i + 1);
    audio.onerror = () => play(i + 1);
    const started = audio.play();
    if (started && typeof started.catch === 'function') started.catch(() => play(i + 1));
  };
  play(0);
}

export function speakArabic(parts) {
  stopSpeech();
  const urls = parts.map(clipUrl).filter(Boolean);
  if (!urls.length) return;
  playClips(urls);
}

function speakBrowser(text, lang, voiceUri, rate) {
  if (typeof window === 'undefined' || !window.speechSynthesis || !text.trim()) return;
  const utter = new SpeechSynthesisUtterance(text);
  const voice =
    (voiceUri && allVoices().find((v) => v.voiceURI === voiceUri)) ||
    allVoices().find(
      (v) => v.lang.toLowerCase().startsWith(lang === 'ar' ? 'ar' : 'en') && isFemale(v)
    ) ||
    allVoices().find((v) => v.lang.toLowerCase().startsWith(lang === 'ar' ? 'ar' : 'en'));
  if (voice) {
    utter.voice = voice;
    utter.lang = voice.lang;
  } else {
    utter.lang = lang === 'ar' ? 'ar-SA' : 'en-US';
  }
  utter.rate = rate ?? 0.95;
  utter.pitch = 1;
  window.speechSynthesis.resume();
  window.speechSynthesis.speak(utter);
}

export function speak(text, lang, opts) {
  if (lang === 'ar') {
    speakArabic(opts?.parts?.length ? opts.parts : [text]);
    return;
  }
  stopSpeech();
  speakBrowser(text, lang, opts?.voiceUri, opts?.rate);
}

export function preloadVoices(onChange) {
  if (onChange) onChange();
  if (typeof window === 'undefined' || !window.speechSynthesis) return () => {};
  const notify = () => onChange && onChange();
  window.speechSynthesis.addEventListener('voiceschanged', notify);
  window.speechSynthesis.getVoices();
  return () => window.speechSynthesis.removeEventListener('voiceschanged', notify);
}

export function preloadArabicClips() {
  ['ui-sample', 'ui-voice-on', 'prompt-actor-m', 'prompt-actor-f', 'prompt-director', 'prompt-film'].forEach(
    (id) => {
      const url = CLIPS[id];
      if (!url) return;
      const audio = new Audio();
      audio.preload = 'metadata';
      audio.src = url;
    }
  );
}
